import { defineSagaForService } from '@repo/core'
import { changePassword } from '@repo/user-services'
import { changePasswordActions } from '../../../slices'

export const changePasswordMutationsServiceConfig = defineSagaForService({
  [changePasswordActions.postRequest.type]: {
    apiClientDomain: 'user',
    service: changePassword,
    actionTypeResponse: changePasswordActions.postResponse.type,
    actionTypeRequest: changePasswordActions.postRequest.type,
  },
})
